export default "__VITE_ASSET__DAzYjCL5__"